import React from 'react';
import { getDisplayName } from '@vmos2/utils';

export function withErrorBoundary(fallbackRender) {
  return EnhancedComponent => {
    class ErrorBoundary extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          hasError: false,
        };
      }

      componentDidCatch(error) {
        console.log(error); // eslint-disable-line
        this.setState({
          hasError: true,
        });
      }

      render() {
        const { hasError } = this.state;
        if (hasError) {
          return fallbackRender(this.props);
        }
        return <EnhancedComponent {...this.props} />;
      }
    }
    ErrorBoundary.displayName = `withErrorBoundary(${getDisplayName(EnhancedComponent)})`;
    return ErrorBoundary;
  };
}
